import { RoutesService } from '@abp/ng.core';
import { ConfigService } from '@abp/ng.theme.basic';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import {
  BaseAppComponent,
  ConfigStateService,
  ErrorNotifierService,
  FeatureHubService,
  OdysseyLanguageService,
} from '@digiwall/core';
import { eThemeSharedRouteNames, NavItemsService } from '@abp/ng.theme.shared';
import {
  ALL_INFORMATION_MESSAGE_DISPLAYERS,
  INFORMATION_MESSAGE_DISPLAYERS,
  NavNotificationDisplayerComponent,
} from '@digiwall/core-features';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: false,
  selector: 'app-root',
  styles: ['body { font-size: 50px;}'],
  template: `
    <abp-loader-bar></abp-loader-bar>
    @if (loading) {
      <dw-ui-spinning-loader></dw-ui-spinning-loader>
    }
    <abp-dynamic-layout></abp-dynamic-layout>
    <dw-ui-floating-track>
      @if (errorNotifierService.hasErrors()) {
        <dw-ui-floating-container>
          <dw-ui-floating-button
            (mouseenter)="showErrors = true"
            (mouseleave)="showErrors = false"
            trigger
            [backgroundColor]="'var(--bs-danger)'"
            [icon]="'digi-out-error-message'"
            [label]="'Communication:Error' | abpLocalization"
          >
          </dw-ui-floating-button>
        </dw-ui-floating-container>
      }
    </dw-ui-floating-track>
    <dw-core-error-notifier [showErrors]="showErrors"></dw-core-error-notifier>
  `,
  providers: [
    {
      provide: INFORMATION_MESSAGE_DISPLAYERS,
      useValue: ALL_INFORMATION_MESSAGE_DISPLAYERS,
    },
  ],
})
export class AppComponent extends BaseAppComponent implements OnInit, OnDestroy {
  errorNotifierService = inject(ErrorNotifierService);
  private destroyRef = inject(DestroyRef);
  showErrors = false;

  protected favIcon: HTMLLinkElement = document.querySelector('#favIcon');

  constructor(
    configState: ConfigStateService,
    private configService: ConfigService,
    private routes: RoutesService,
    private navItems: NavItemsService,
    private featureHubService: FeatureHubService,
    //Do not remove odysseyLanguageService
    private odysseyLanguageService: OdysseyLanguageService,
  ) {
    super();
    configState.isAuthenticated$.subscribe(x => this.patchRoutes(x));
  }

  private patchRoutes(isAuthenticated: boolean) {
    this.routes.patch(eThemeSharedRouteNames.Administration, {
      invisible: !isAuthenticated,
      iconClass: '',
    });
    this.navItems.addItems([
      {
        id: 'informationMessages',
        order: 1,
        component: NavNotificationDisplayerComponent,
        visible: () => isAuthenticated,
      },
    ]);
  }

  ngOnInit() {
    super.ngOnInit();

    const favIconURI = this.configService?.config?.favIconPictureURI;
    if (favIconURI && this.favIcon) {
      this.favIcon.href = favIconURI;
    }

    if (this.configService?.config?.colorTheme) {
      const body = document.body;
      body.classList.add(this.configService?.config?.colorTheme);
    }

    this.featureHubService.startConnection().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    this.featureHubService
      .receiveRefreshAll()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  ngOnDestroy(): void {
    this.featureHubService.endConnection();
  }
}
